/**
 * Determines whether the manifest section should be displayed for a listing.
 * Contract listings and item-scoped offerings do not have manifests.
 */
export function shouldShowManifestSection(listing: {
  listingType?: string
  offering?: { offerScope?: string } | null
}): boolean {
  return !(
    listing.listingType === 'CONTRACT' ||
    listing.offering?.offerScope === 'ITEM'
  )
}
